<template>
  <div class="">
    <div class="ibox">
      <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
        Show Filters <i class="fa fa-bars"></i>
      </a>
      <div class="ibox-results-filters-collapse-box collapse in">
        <div class="ibox-results-filters">

          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-group">
                <label class="control-label">Search</label>
                <input type="text" class="form-control" placeholder="..." @input="updateKeywords"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label">User Type</label>
                <selectize
                  v-model="type"
                  name="type"
                  :options="typeOptions"
                  class="form-control select2-material-placeholder">
                </selectize>
              </div>
            </div>
            <div class="col-sm-6 col-lg-2">
              <div class="form-group">
                <label class="control-label">Master Accounts</label>
                <div class="checkbox">
                  <input id="check-master" class="styled" type="checkbox" checked="" v-model="master" />
                  <label for="check-master">
                    Yes
                  </label>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-2">
              <div class="form-group">
                <label class="control-label">Show Archived</label>
                <div class="checkbox">
                  <input id="check-archive" class="styled" type="checkbox" checked="" v-model="archived" />
                  <label for="check-archive">
                    Yes
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="ibox-content">
        <ul class="list-detail list-detail-user">
          <li v-for="user in usersDecorated" :key="'users-' + user.id">
            <div class="row">
              <div class="col-md-5 col-lg-3">
                <h2 class="truncate"><strong>{{ user.profile.full_name }}</strong></h2>
              </div>
              <div class="col-md-4 col-lg-3">
                <p class="truncate">
                  <i class="fa fa-at"></i>
                  <a :href="`mailto:${user.email}`">{{ user.email }}</a>
                </p>
              </div>
              <div class="col-md-3 col-lg-3">
                <p class="truncate">
                  <i class="fa fa-phone"></i>
                  <a :href="`tel:${user.mobile}`">{{ user.mobile}}</a>
                </p>
              </div>
              <div class="col-md-12 col-lg-3">
                <div class="pull-right">
                    <span v-if="user.active" class="status status-enabled">Enabled</span>
                    <span v-else class="status status-disabled">Disabled</span>

                    <router-link v-if="user.isClient" :to="{ name: 'users.overview', params: { id: user.id }}" class="btn btn-circle btn-info"><i class="fa fa-building"></i></router-link>
                    <router-link v-if="user.isCarrier" :to="{ name: 'users.overview', params: { id: user.id }}" class="btn btn-circle btn-info"><i class="fa fa-truck"></i></router-link>
                    <router-link v-if="user.isDriver" :to="{ name: 'drivers.edit', params: { id: user.id } }" class="btn btn-circle btn-primary"><i class="fa fa-user"></i></router-link>
                    <router-link v-else :to="{ name: 'users.edit', params: { id: user.id } }" class="btn btn-circle btn-primary"><i class="fa fa-user"></i></router-link>
                </div>
              </div>
            </div>

            <ul class="details" >
              <li v-show="!user.isDriver"><span>Company:</span> {{ user.profile.company_name }}.</li>
              <li v-show="!user.isDriver"><span>Phone:</span> {{ user.profile.company_phone }}</li>
              <li v-if="!user.parent_id && !user.isDriver">MASTER</li>
              <li>&nbsp;</li>
            </ul>
          </li>
        </ul>

        <div class="text-center text-muted" v-show="haveNoUsers">
          <strong>There are no users.</strong>
        </div>
      </div>
      <lazy-loading v-show="haveUsers" :reached-bottom="getUsersForNextPage" :filters="filters" ref="lazyLoading">
        <strong slot="finished" class="text-muted">There are no more users.</strong>
      </lazy-loading>
    </div>
  </div>
</template>

<script>
  import { Selectize } from 'components/forms'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { isEqual, debounce, remove } from 'lodash'
  import { Roles } from 'utils/user'
  import { LazyLoading } from 'components/misc'

  export default {
    components: {
      Selectize,
      LazyLoading
    },

    data () {
      return {
        keywords: '',
        type: 'all',
        master: true,
        archived: false
      }
    },

    created () {
      this.getUsers(this.filters)
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

          this.getUsers(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    computed: {
      ...mapState('user', ['users']),
      ...mapGetters('user', ['usersDecorated']),

      /**
       * Filters object is computed to track changes.
       *
       * @return object
       */
      filters () {
        return {
          keywords: this.keywords,
          type: this.type,
          master: this.master,
          archived: this.archived
        }
      },

      /**
       * User type dropdown options.
       *
       * @return array
       */
      typeOptions () {
        let types = [
          { id: 'all', text: 'All' },
          { id: Roles.CLIENT, text: 'Client' },
          { id: Roles.CARRIER, text: 'Carrier' },
          { id: Roles.COORDINATOR, text: 'Coordinator' },
          { id: Roles.DRIVER, text: 'Driver' },
          { id: Roles.ADMIN, text: 'Administrator' }
        ]

        if (this.$user.isCoordinator) {
          remove(types, type => type.id === Roles.COORDINATOR || type.id === Roles.ADMIN)
        }

        return types
      },

      /**
       * Determine if we have users.
       *
       * @return boolean
       */
      haveUsers () {
        return this.users.length > 0
      },

      /**
       * Determine if we have no users.
       *
       * @return boolean
       */
      haveNoUsers () {
        return this.users.length === 0
      }
    },

    methods: {
      ...mapActions('user', [
        'getUsers',
        'getUsersForNextPage'
      ]),

      /**
       * Debounce updating of keywords so we don't poll API immediately for new users.
       *
       * @param object event
       *
       * @return Function
       */
      updateKeywords: debounce(function (event) {
        this.keywords = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// Users.vue?4ce70f7e